import React from 'react'
import Cropper from 'react-easy-crop'
import './styles.css'
import { getCroppedImg } from './canvasUtils'
import Constant from '../../Constant'

class ImageCropper extends React.Component {
  state = {
    imageSrc: null,
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 1 / 1,
    croppedAreaPixels: null,
  }

  componentDidMount() {
    // if (this.props.ratio) {
    //     this.setState({
    //         aspect: this.props.ratio
    //     })
    // }
  }

  componentDidUpdate() {
    if (this.props.ratio != this.state.aspect) {
      this.setState(
        {
          aspect: this.props.ratio,
          imageSrc: null,
        },
        () => {
          this.image_input.value = null
        }
      )
    }
  }

  onCropChange = (crop) => {
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels: croppedAreaPixels }, () => {
      this.getCroppedImage()
    })
  }

  onZoomChange = (zoom) => {
    this.setState({ zoom })
  }

  handleChangeImage = (e) => {
    this.setState({ imageSrc: URL.createObjectURL(e.target.files?.[0]) })
  }

  getCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(this.state.imageSrc, this.state.croppedAreaPixels, 0)
      this.props.onChange(croppedImage || null)
    } catch (e) {
      console.error(e) // eslint-disable-line no-console
    }
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <input
                ref={(ref) => (this.image_input = ref)}
                className="image w-100"
                type="file"
                id="img"
                name="img_path"
                accept="image/*"
                onChange={this.handleChangeImage}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 cropper-container">
            <div className="crop-container">
              {this.state.imageSrc ? (
                <Cropper
                  image={this.state.imageSrc}
                  crop={this.state.crop}
                  zoom={this.state.zoom}
                  aspect={this.state.aspect}
                  onCropChange={this.onCropChange}
                  onCropComplete={this.onCropComplete}
                  onZoomChange={this.onZoomChange}
                />
              ) : (
                <img
                  height="200px"
                  src={this.props.img ? Constant.getImage() + this.props.img : './assets/images/no_image.png'}
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              )}
            </div>
            {/* <div className="controls">
                            <Slider
                                value={this.state.zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e, zoom) => this.onZoomChange(zoom)}
                                classes={{ container: 'slider' }}
                            />
                        </div> */}
          </div>
        </div>
      </>
    )
  }
}

export default ImageCropper
